import { t } from 'ttag';

import { DEFAULT_STYLE_CONFIG } from './shared';

// These are the API's appliedEntityType values, so the form value ships as-is.
export const PEOPLE_DISPLAY_MODE = {
  GROUP: 'people_groups',
  SPECIFIC: 'specific_people',
  SHOW_ALL: 'all',
};

export const getPeopleDisplayOptions = () => [
  { label: t`People Group`, value: PEOPLE_DISPLAY_MODE.GROUP },
  { label: t`Specific People`, value: PEOPLE_DISPLAY_MODE.SPECIFIC },
  { label: t`Show All`, value: PEOPLE_DISPLAY_MODE.SHOW_ALL },
];

// The API rejects these group types in appliedEntities.
export const HIDDEN_PEOPLE_GROUP_TYPES = ['reg_ticket_types', 'eventmobi_support'];

// Seeds new widgets, and stands in when a saved one has no sort.
export const PEOPLE_DEFAULT_SORT = 'first_name';

// -> queryConfig.sort
export const getPeopleSortOptions = () => [
  { label: t`First Name`, value: 'first_name' },
  { label: t`Last Name`, value: 'last_name' },
  { label: t`Company`, value: 'company_name' },
];

// Always shown, so it isn't a checkbox.
export const PEOPLE_NAME_FIELDS = ['first_name', 'last_name'];

// People-only field. The token shows custom fields, customFieldIds picks which ones.
export const CUSTOM_FIELDS_VIEW_FIELD = 'custom_fields';

// -> fieldConfig.viewFields. The checklist splits this list down
// the middle into two columns, so the order is the layout.
export const getPeopleFieldOptions = () => [
  { label: t`Profile Picture`, value: 'profile_image' },
  { label: t`Pronouns`, value: 'pronouns' },
  { label: t`Company`, value: 'company_name' },
  { label: t`Title/Position`, value: 'title' },
  { label: t`About`, value: 'about' },
  { label: t`Website`, value: 'website' },
  { label: t`X (formerly Twitter)`, value: 'twitter_url' },
  { label: t`LinkedIn`, value: 'linkedin_url' },
  { label: t`Facebook`, value: 'facebook_url' },
  { label: t`Sessions this person is speaking at`, value: 'speaking_sessions' },
];

// Round avatars, both filters on.
export const PEOPLE_STYLE_CONFIG = {
  ...DEFAULT_STYLE_CONFIG,
  image: { size: 200, cornerRadius: 100 },
  widgetFilters: { showSearch: true, alphabeticalSorting: true },
};
